// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".requisites-send-modal .requisites-send-modal__details{display:flex}.requisites-send-modal .requisites-send-modal__details li{margin-right:4px;padding-left:9px}.requisites-send-modal .requisites-send-modal__details li:first-child{padding-left:0}.requisites-send-modal .requisites-send-modal__details li:before{content:\"\"}.requisites-send-modal .requisites-send-modal__details li:not(:first-child):before{content:\"•\"}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
